/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S2_TitleInputs */

const en_guide_large_json_files_s2_title = /** @type {(inputs: Guide_Large_Json_Files_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strategy 1: Minify Before Transferring`)
};

const ko_guide_large_json_files_s2_title = /** @type {(inputs: Guide_Large_Json_Files_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전략 1: 전송 전 압축하기`)
};

const ja_guide_large_json_files_s2_title = /** @type {(inputs: Guide_Large_Json_Files_S2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戦略1：転送前に圧縮する`)
};

/**
* | output |
* | --- |
* | "Strategy 1: Minify Before Transferring" |
*
* @param {Guide_Large_Json_Files_S2_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s2_title = /** @type {((inputs?: Guide_Large_Json_Files_S2_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S2_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s2_title(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s2_title(inputs)
	return ja_guide_large_json_files_s2_title(inputs)
});